module.exports = __webpack_public_path__ + "img/prayer_times_category.02e15432.png";